import { ExternalCalendarEvent, TimeFormatOptions } from '@griply/types';
import { format } from 'date-fns';

import { getCalendarEventReferenceDate } from './get-calendar-event-reference-date';
import { isExternalEventAllDay } from './is-external-event-all-day';

export type ExternalEventTimeLabel =
  | { isAllDay: true }
  | { isAllDay: false; range: string };

const MERIDIEM_PATTERN = 'a';
const TIME_WITHOUT_MERIDIEM_PATTERN = 'h:mm';

// A timed event spanning midnight stays timed rather than widening into the all-day row.
export const getExternalEventTimeLabel = (
  event: ExternalCalendarEvent,
  timeFormat: TimeFormatOptions,
): ExternalEventTimeLabel => {
  if (isExternalEventAllDay(event)) {
    return { isAllDay: true };
  }

  const fallback = new Date(0);
  const start = getCalendarEventReferenceDate(event.start, fallback);
  const end = getCalendarEventReferenceDate(event.end, fallback);

  const sharesMeridiem =
    timeFormat === TimeFormatOptions.Standard &&
    format(start, MERIDIEM_PATTERN) === format(end, MERIDIEM_PATTERN);

  const startLabel = format(
    start,
    sharesMeridiem ? TIME_WITHOUT_MERIDIEM_PATTERN : timeFormat,
  );

  return {
    isAllDay: false,
    range: `${startLabel}-${format(end, timeFormat)}`,
  };
};
